import { config } from "config";
import { Wall } from "wall/types/wall.model";

export class WallService {
  private static headers() {
    return {
      Authorization: `Bearer ${JSON.parse(
        sessionStorage.getItem("quizToken")!,
      )}`,
    };
  }

  getWallById(getWallByIdData: { wallId: string }): Promise<string> {
    return fetch(`${config.apiRoot}/walls/${getWallByIdData.wallId}`, {
      method: "GET",
      headers: WallService.headers(),
    }).then((resp) => resp.json());
  }
  updateWall(updateWallData: {
    wallId: string;
    wall: Omit<Wall, "id">;
  }): Promise<string> {
    return fetch(`${config.apiRoot}/walls/${updateWallData.wallId}`, {
      method: "POST",
      headers: {
        ...WallService.headers(),
      },
      body: JSON.stringify(updateWallData.wall),
    }).then((resp) => resp.json());
  }
  updateWallStatus(updateWallStatusData: {
    wallId: string;
    currentSlideshowIndex?: number;
    totalMessages?: number;
  }): Promise<string> {
    return fetch(`${config.apiRoot}/wall-play-pause`, {
      method: "POST",
      headers: {
        ...WallService.headers(),
      },
      body: JSON.stringify(updateWallStatusData),
    }).then((resp) => resp.json());
  }
}
